import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import appRoutes from '../../routes/routeConfig';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { CircularProgress } from '@mui/material';
import TextInput from '../../components/common/TextInput';
import { signInUser } from '../../redux/actions/userActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EventType } from '@azure/msal-browser';
import { loginRequest } from '../../ADAuthConfig';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

const Login = ({ signInUser, user }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const login = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            if (values.password) {
                const user = await signInUser(values);
                history.push(appRoutes.internal.root);
            } else {
                if (values.username) {
                    if (process.env.NODE_ENV == 'development') {
                        await signInUser({ username: values.username, password: 'password' }, 'light');
                    } else {
                        await handleLoginWithUsername(values.username);
                    }
                } else {
                    enqueueSnackbar('User Account Not Found', { variant: 'error' });
                }
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
            setError(err);
        } finally {
            setSubmitting(false);
        }
    };

    const { instance } = useMsal();

    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleLoginWithUsername = (username) => {
        setLoading(true);
        instance
            .loginPopup(loginRequest(username))
            .then(async (response) => {
                if (response.accessToken) {
                    await signInUser({ username, password: 'password' }, 'light');
                    history.push(appRoutes.internal.root);
                }
            })
            .catch((error) => {
                enqueueSnackbar(error?.message ?? 'An error occurred', { variant: 'error' });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (user.authenticated) {
            history.push(appRoutes.internal.root);
        }
    }, [user]);

    return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-6 col-md-8 col-sm-10 col-xl-4 mx-auto" style={{ minWidth: 'fit-content' }}>
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <Link to="/" className="logo logo-admin mt-05">
                                                <img src="assets/images/logo-sm.png" height="50" alt="CBN logo" className="auth-logo " />
                                            </Link>
                                            <h4 className="mt-1 mb-05 font-weight-semibold text-white font-18">Consumer Complaints Management System</h4>
                                            <p className="text-white mb-0">Internal Portal</p>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <div className="tab-pane active p-3 pt-1" id="LogIn_Tab" role="tabpanel">
                                                <Formik
                                                    initialValues={{
                                                        username: '',
                                                        password: '',
                                                    }}
                                                    validationSchema={Yup.object().shape({
                                                        username: Yup.string().required('Username is required.'),
                                                        // password: Yup.string().required('Password is required.'),
                                                    })}
                                                    onSubmit={login}
                                                >
                                                    {({ isSubmitting }) => (
                                                        <Form className="form-horizontal auth-form">
                                                            <div className="form-group">
                                                                <TextInput label="Username" name="username" id="username" required placeholder="Enter username (surname + id number)" />
                                                            </div>
                                                            {process.env.NODE_ENV == 'development' && (
                                                                <div className="form-group">
                                                                    <TextInput id="password" label="Password" type={'password'} />
                                                                </div>
                                                            )}
                                                            {Boolean(error?.message) && <p className="error text-center">{error?.message}</p>}
                                                            <div className="form-group mb-0 row">
                                                                <div className="col-12 mt-1">
                                                                    <button disabled={isSubmitting || loading} className="btn btn-primary btn-block waves-effect waves-light" type="submit">
                                                                        {isSubmitting || loading ? (
                                                                            <CircularProgress size={13} color="inherit" />
                                                                        ) : (
                                                                            <>
                                                                                Log In
                                                                                <i className="fas fa-sign-in-alt ml-1"></i>
                                                                            </>
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; {new Date().getFullYear()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ signInUser }, dispatch);
};

export default connect(({ user }) => ({ user }), mapDispatchToProps)(Login);
